import { NavbarElement } from '@/interfaces'
import { AuthenticationInformation } from '@/oidc'

export function getMobileElements(user: AuthenticationInformation): NavbarElement[] {
  return [
    {
      id: 'fruitcore-main',
      title: 'FRUITCORE.COM',
      icon: 'bi-fc-logo',
      externalLink: process.env.VUE_APP_FRUITCORE_ROBOTICS_HOME,
    },
    {
      title: 'Fleet',
      titleLocale: 'messages.navbar.myRobots',
      icon: 'bi-robot',
      link: '/fleet',
      id: 'fleet',
      visible: () => user.isAuthenticated,
    },
  ]
}
